import React, { useRef, useContext, useEffect, useState } from "react";
import { Card, CardActions, CardContent, Button, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { AxiosContext } from "../../../app/assets/axios/admin/AxiosComponent";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { useNavigate, useLocation } from "react-router-dom";
import { postEditForm, fetchEditInfoList } from "../../../actions/admin/actionCreators";
import TextFieldComponent from "../../FormAddInputComponent/TextField";
import SelectOptionComponent from "../../FormAddInputComponent/SelectOption";
import { AppBarSpacer, CardHeaderCss } from "../../../css/Admin-css/listing-css";
import CollapsedBreadcrumbs, { BreadcrumbsContext } from "../../../layouts/admin/breadcrumb";

export default function UserUpdate(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const api = useContext(AxiosContext);
    const { enqueueSnackbar } = useSnackbar();
    const [status, setStatus] = useState("");
    const password = useRef({});
    const location = useLocation();
    const { country_id } = location?.state ? location.state : 0;

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        mode: "all",
        defaultValues: {
			code: "",
			name: "",
			size_nsn: "",
            prefix_calling_code: "",
            status: "",
		},
    });

    const statusList = [
        { id: "A", name: "Active" },
        { id: "I", name: "Inactive" },
    ];

    const [breadcrumbArr, setBreadcrumbArr] = React.useState([
        {
            text: "Country",
            link: "/admin/country-list",
        },
        {
            text: "Update Country",
            link: "",
        },
    ]);

    const onSubmit = handleSubmit(async (data) => {
        data["country_id"] = country_id;

        document.getElementById("splash-screen").classList.remove("hidden");

        const response = await postEditForm({
            api: api,
            data: data,
            method: "POST",
            url: "updateCountry",
            enqueueSnackbar,
        });

        if (response) {
            if (response.status === 200) {
                enqueueSnackbar(response.data.msg, {
                    variant: response.data.msgType,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                });
                if (response.data.msgType == 'success') navigate("/admin/country-list");
            }
        }
        document.getElementById("splash-screen").classList.add("hidden");
    });

    const getCountryInfo = async (id) => {
        const response = await fetchEditInfoList({
            api: api,
            url: "getCountryList",
            data: {
                country_id: id,
            },
            enqueueSnackbar,
            dispatch,
        });

        if (response) {
            if (response.data.data) {
                setValue("code", response.data.data[0].code);
                setValue("name", response.data.data[0].name);
                setValue("size_nsn", response.data.data[0].size_nsn);
                setValue("prefix_calling_code", response.data.data[0].prefix_calling_code);
                setValue("status", response.data.data[0].status);
                setStatus(response.data.data[0].status);
            }
        }
    };

    const onSelectChangeHandler = (name) => (event) => {
        const value = event.target.value;
        if (name == "status") {
            setStatus(value);
        }
        setValue(name, value);
    };

    useEffect(() => {
        if (country_id) {
            getCountryInfo(country_id);
        }
    }, []);

    return (
        <>
            <BreadcrumbsContext.Provider value={[breadcrumbArr, setBreadcrumbArr]} >
                <CollapsedBreadcrumbs />
            </BreadcrumbsContext.Provider>
            <Card>
                <CardHeaderCss title="Country Form" />
                <CardContent>
                    <form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="code"
                                    marginType="normal"
                                    label="Code"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="name"
                                    marginType="normal"
                                    label="Name"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="size_nsn"
                                    placeholder="Single Number or Range like (9 or 9,13)"
                                    marginType="normal"
                                    label="NSN Length"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        pattern: {
                                            value: /^[-,0-9]+$/i,
                                            message: "invalid NSN Length, Single Number or Range like (9 or 9,13)"
                                        }
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="prefix_calling_code"
                                    placeholder="Single Number like (60)"
                                    marginType="normal"
                                    label="Calling Codes"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        pattern: {
                                            value: /^[0-9]+$/i,
                                            message: "invalid Calling Codes, Single Number like (60)"
                                        }
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <SelectOptionComponent
                                    control={control}
                                    name="status"
                                    placeholder="Status"
                                    label="Status"
                                    option={statusList}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                    onChangeHandler={onSelectChangeHandler("status")}
                                    value={status}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
            <AppBarSpacer />
            <CardActions
                style={{ justifyContent: "center", marginBottom: "16px" }}
            >
                <div align="center">
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={onSubmit}
                    >
                        Update
                    </Button>
                </div>
            </CardActions>
        </>
    );
}
